<template>
<v-app>
    <MovingBackground />
    <SolidBackground />
    <v-main>
        <v-container>
            <router-view></router-view>
        </v-container>
        <Footer />
    </v-main>
    <v-btn color="success" @click="call" :disabled="snackbar" fixed right bottom fab dark>
        <v-icon>mdi-phone-in-talk</v-icon>
    </v-btn>

    <v-snackbar large class="pa-8" color="success" height="300" :centered="isMoblie" :right="!isMoblie" v-model="snackbar" :timeout="timeout">
        Numer telefonu:
        <strong>
            <v-btn :href="'tel:' + phoneNumber" text> {{ phoneNumber }}</v-btn>
        </strong>

        <template v-slot:action="{ attrs }">
            <v-btn small elevation="0" fab dark text v-bind="attrs" @click="snackbar = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
    </v-snackbar>

    <Menu />
</v-app>
</template>

<script>
//import HelloWorld from './components/HelloWorld';
import Menu from "./components/Menu";
import Footer from "./components/Footer";
import MovingBackground from "./components/MovingBackground";
import SolidBackground from "./components/SolidBackground";

export default {
    name: "App",

    components: {
        Menu,
        Footer,
        MovingBackground,
        SolidBackground,
    },

    data: () => ({
        phoneNumber: "+48 506 972 803",
        test: true,
        snackbar: false,
        timeout: 15000,
        isMoblie: true,
        clicked: false
    }),
    methods: {
        call() {
            console.log(this.isMobile);
            this.snackbar = true;
            if (this.isMobile && !this.clicked) {
                window.location.href = `tel:${this.phoneNumber}`;
                this.clicked = true;
            }
        },
        onResize() {
            this.isMobile = window.innerWidth < 768;
            if (this.$store.getters.isMobile != this.isMobile) {
                this.$store.commit('changeSize')
            }
        },
    },
    beforeDestroy() {
        if (typeof window === "undefined") return;

        window.removeEventListener("resize", this.onResize, {
            passive: true
        });
    },
    mounted() {
        this.onResize();

        window.addEventListener("resize", this.onResize, {
            passive: true
        });
    },

    created() {},
};
</script>

<style lang="scss">
@font-face {
    font-family: "Montserrat-Light";
    src: local("Montserrat-Light"),
        url(./assets/fonts/Montserrat-Light.ttf) format("truetype");
}

* {
    font-family: "Montserrat-Light", sans-serif;
    box-sizing: border-box;
}

.costum-icon {
    fill: white;
}

.v-snack__content a:link {
    color: #fff !important;
    text-decoration: none;
}
</style>
